import {Injectable, NgZone} from '@angular/core';

import {Observable, Subscriber} from 'rxjs';

import {ExgMapRectangleComponent} from '../../exg-map-rectangle/exg-map-rectangle.component';
import {ExgMapGoogleAPIWrapper} from '../exg-map-google-api-wrapper.service';

@Injectable()
export class ExgMapRectangleManagerService {
  private _rectangles: Map<ExgMapRectangleComponent, Promise<google.maps.Rectangle>> =
    new Map<ExgMapRectangleComponent, Promise<google.maps.Rectangle>>();

  constructor(private _apiWrapper: ExgMapGoogleAPIWrapper, private _zone: NgZone) {
  }

  addRectangle(rectangle: ExgMapRectangleComponent): void {
    this._rectangles.set(rectangle, this._apiWrapper.getNativeMap().then(() =>
      this._apiWrapper.createRectangle({
        bounds: {
          north: rectangle.north,
          east: rectangle.east,
          south: rectangle.south,
          west: rectangle.west,
        },
        clickable: rectangle.clickable,
        draggable: rectangle.draggable,
        editable: rectangle.editable,
        fillColor: rectangle.fillColor,
        fillOpacity: rectangle.fillOpacity,
        strokeColor: rectangle.strokeColor,
        strokeOpacity: rectangle.strokeOpacity,
        strokePosition: google.maps.StrokePosition[rectangle.strokePosition],
        strokeWeight: rectangle.strokeWeight,
        visible: rectangle.visible,
        zIndex: rectangle.zIndex,
      }))
    );
  }

  /**
   * Removes the given rectangle from the map.
   */
  removeRectangle(rectangle: ExgMapRectangleComponent): Promise<void> {
    // @ts-ignore
    return this._rectangles.get(rectangle).then((r) => {
      r.setMap(null);
      this._rectangles.delete(rectangle);
    });
  }

  setOptions(rectangle: ExgMapRectangleComponent, options: google.maps.RectangleOptions): Promise<void> {
    // @ts-ignore
    return this._rectangles.get(rectangle).then((r) => {
      const actualStrokePosition = options.strokePosition as any as keyof typeof google.maps.StrokePosition;
      options.strokePosition = google.maps.StrokePosition[actualStrokePosition];
      r.setOptions(options);
    });
  }

  getBounds(rectangle: ExgMapRectangleComponent): Promise<google.maps.LatLngBounds> {
    // @ts-ignore
    return this._rectangles.get(rectangle).then((r) => r.getBounds());
  }

  setBounds(rectangle: ExgMapRectangleComponent): Promise<void> {
    // @ts-ignore
    return this._rectangles.get(rectangle).then((r) => {
      return r.setBounds({
        north: rectangle.north,
        east: rectangle.east,
        south: rectangle.south,
        west: rectangle.west,
      });
    });
  }

  setEditable(rectangle: ExgMapRectangleComponent): Promise<void> {
    // @ts-ignore
    return this._rectangles.get(rectangle).then((r) => {
      return r.setEditable(rectangle.editable);
    });
  }

  setDraggable(rectangle: ExgMapRectangleComponent): Promise<void> {
    // @ts-ignore
    return this._rectangles.get(rectangle).then((r) => {
      return r.setDraggable(rectangle.draggable);
    });
  }

  setVisible(rectangle: ExgMapRectangleComponent): Promise<void> {
    // @ts-ignore
    return this._rectangles.get(rectangle).then((r) => {
      return r.setVisible(rectangle.visible);
    });
  }

  createEventObservable<T>(eventName: string, rectangle: ExgMapRectangleComponent): Observable<T> {
    return new Observable((subsrciber: Subscriber<T>) => {
      let listener: google.maps.MapsEventListener | null = null;
      // @ts-ignore
      this._rectangles.get(rectangle).then((r) => {
        listener = r.addListener(eventName, (e: T) => this._zone.run(() => subsrciber.next(e)));
      });

      return () => {
        if (listener !== null) {
          listener.remove();
        }
      };
    });
  }
}
